(function(angular){
	'use strict';
	
	var historicalReturnsTableObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			reitUrlSlug: '@'
		},
		controller: [
			'$timeout',
			'mixpanelFactory',
			'urlFactory',
			HistoricalReturnsTableFunction
		],
		controllerAs: 'historicalReturnsTable'
	};
	
	angular
		.module('productPage')
		.component('historicalReturnsTable', historicalReturnsTableObject);
	
	function templateUrlFunction(STATIC_BASE_PATH) {
		return STATIC_BASE_PATH + '/static/html/reits/product-pages/historical-returns-table.html';
	}
	
	function HistoricalReturnsTableFunction(
		$timeout,
		mixpanelFactory,
		urlFactory){

		var historicalReturnsTable = this;

		historicalReturnsTable.allMonths = [{
			month: 'Jan',
			monthOrdinal: 0,
			quarter: 'Q1'
		},{
			month: 'Feb',
			monthOrdinal: 1,
			quarter: 'Q1'
		},{
			month: 'Mar',
			monthOrdinal: 2,
			quarter: 'Q1'
		},{
			month: 'Apr',
			monthOrdinal: 3,
			quarter: 'Q2'
		},{
			month: 'May',
			monthOrdinal: 4,
			quarter: 'Q2'
		},{
			month: 'Jun',
			monthOrdinal: 5,
			quarter: 'Q2'
		},{
			month: 'Jul',
			monthOrdinal: 6,
			quarter: 'Q3'
		},{
			month: 'Aug',
			monthOrdinal: 7,
			quarter: 'Q3'
		},{
			month: 'Sep',
			monthOrdinal: 8,
			quarter: 'Q3'
		},{
			month: 'Oct',
			monthOrdinal: 9,
			quarter: 'Q4'
		},{
			month: 'Nov',
			monthOrdinal: 10,
			quarter: 'Q4'
		},{
			month: 'Dec',
			monthOrdinal: 11,
			quarter: 'Q4'
		},{
			month: 'YTD',
			monthOrdinal: 12,
			quarter: 'YTD'
		}];

		historicalReturnsTable.quarters = ['Q1', 'Q2', 'Q3', 'Q4', 'YTD'];
		historicalReturnsTable.activeMobileColumn = 'YTD';

		historicalReturnsTable.setActiveMobileColumn = function(quarter) {
			historicalReturnsTable.activeMobileColumn = quarter;

			mixpanelFactory.track('Performance Table - Set Active Column', {
				'Table': 'REIT Historical Performance',
				'Column': quarter
			});
		};

		historicalReturnsTable.$onInit = function() {
			urlFactory.getPromise('/reits/' + historicalReturnsTable.reitUrlSlug + '/historical-performance.json')
				.then(
					function(response) {

						historicalReturnsTable.data = response.data;
						historicalReturnsTable.loaded = true;

						angular.forEach(historicalReturnsTable.data, function(year) {

							var lastMonthWithData;

							angular.forEach(historicalReturnsTable.allMonths, function(globalMonth) {

								var hasGlobalMonth = false;

								angular.forEach(year.months, function(monthWithData) {
									if(globalMonth.month === monthWithData.month) {
										hasGlobalMonth = true;
										lastMonthWithData = monthWithData;
										angular.extend(monthWithData, globalMonth);
									}
								});

								if(!hasGlobalMonth) {
									year.months.push(globalMonth);
								}
							});

							year.months[12] = {
								month: 'YTD',
								monthOrdinal: 12,
								navAtMonthEnd: lastMonthWithData.navAtMonthEnd,
								dividendReturn: lastMonthWithData.dividendYearToDateReturn,
								navReturn: lastMonthWithData.navYearToDateReturn,
								totalReturn: lastMonthWithData.totalYearToDateReturn,
								quarter: 'YTD'							
							};
						});


						$timeout(function() {
							historicalReturnsTable.data[historicalReturnsTable.data.length - 1].expanded = true;
						});
					}
				);
		};
	}
})(window.angular);